import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TaxExemptionStatus } from 'store/shop';

interface CreateTaxExemption {
  marketplaceItemId: string;
  taxExemptions: Array<{ country: string; status: TaxExemptionStatus }>;
}

interface UpdateTaxExemption {
  taxExemptionId: string;
  country: string;
  status: TaxExemptionStatus;
}

interface DeleteTaxExemption {
  taxExemptionId: string;
}

interface BulkUpdateTaxExemption {
  marketplaceItemIds: string[];
  country: string;
  status: TaxExemptionStatus;
}

export const loaders = {
  createTaxExemption: ({
    marketplaceItemId,
    taxExemptions,
  }: CreateTaxExemption) => {
    return api({
      url: Endpoints.melpAdmin.taxExemption.byMarketplaceItem.replace(
        ':shopItemId',
        marketplaceItemId,
      ),
      context: 'melp',
      method: 'post',
      data: { taxExemptions },
    });
  },
  updateTaxExemption: ({
    taxExemptionId,
    country,
    status,
  }: UpdateTaxExemption) => {
    return api({
      url: Endpoints.melpAdmin.taxExemption.byId.replace(
        ':taxExemptionId',
        taxExemptionId,
      ),
      context: 'melp',
      method: 'patch',
      data: { country, status },
    });
  },
  deleteTaxExemption: ({ taxExemptionId }: DeleteTaxExemption) => {
    return api({
      url: Endpoints.melpAdmin.taxExemption.byId.replace(
        ':taxExemptionId',
        taxExemptionId,
      ),
      context: 'melp',
      method: 'delete',
    });
  },
  bulkUpdateTaxExemption: (data: BulkUpdateTaxExemption) => {
    return api({
      url: Endpoints.melpAdmin.taxExemption.bulk,
      context: 'melp',
      method: 'patch',
      data,
    });
  },
};
